import { CreateUserDTO } from './create-user.dto'

export class CreateUsersRequestDTO {
  constructor(public newUsers: CreateUserDTO[]) {}
}
